import types from '@constants/action-types';
import { reducerFactory } from '@factories';

export const initialState = {
  isLoading: false,
  results: [],
  error: null,
};
export default reducerFactory(initialState, {
  [types.UPLOAD_FILES_REQUEST]: state => ({ ...state, isLoading: true, error: null }),
  [types.UPLOAD_FILES_SUCCESS]: (state, { response }) => ({
    ...state,
    isLoading: false,
    ...response.files,
  }),
  [types.UPLOAD_FILES_FAILURE]: (state, { response }) => ({
    ...state,
    isLoading: false,
    error: response.error,
  }),
});
